var _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSend = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 10,
    fill: "#EEEBFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1868_1851",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 21,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 9.5,
    width: 19.8261,
    height: 19.8261,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1868_1851)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1868_1851",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 20,
    height: 20
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.91309,
    y: 9.91309,
    width: 19,
    height: 19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1868_1851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2881 24.5587V14.267C12.2881 13.9768 12.4068 13.7556 12.6443 13.6036C12.8818 13.4522 13.1325 13.4292 13.3964 13.5348L25.5881 18.6806C25.9179 18.8257 26.0829 19.0698 26.0829 19.4129C26.0829 19.7559 25.9179 20 25.5881 20.1452L13.3964 25.291C13.1325 25.3966 12.8818 25.3733 12.6443 25.2213C12.4068 25.0699 12.2881 24.849 12.2881 24.5587ZM13.8714 23.3712L23.2527 19.4129L13.8714 15.4545V18.2254L18.6214 19.4129L13.8714 20.6004V23.3712Z",
    fill: "#493AB1"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSend, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/send.76a1e800.svg";
export { ForwardRef as ReactComponent };